export const WORKFLOWS_LINK_TEST_ID =
	'spa-apps-servicedesk-legacy-board-settings.ui.workflows-link';
